// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframes[data-v-dcbbada6] {\n  width: calc(100vw);\n  height: calc(100vh);\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
